<template>
  <div>
    <div id="home">
      <router-link to="/basic">
        <img class="player" src="./basic.png">
      </router-link>
      <router-link to="/rain">
        <img class="player" src="./rain.png">
      </router-link>
      <router-link to="/dft">
        <img class="player" src="./dft.png">
      </router-link>
      <router-link to="/tonnetz">
        <img class="player" src="./tonnetz.png">
      </router-link>
      <router-link to="/volume">
        <img class="player" src="./volume.png">
      </router-link>
      <router-link to="/info">
        <img class="player" src="./info.png">
      </router-link>
    </div>
    <div class="branding">
      <svg id="volume_f" viewBox="328.00046 476.66 163.19 112.75">
        <g>
          <path id="path_f" d="M 389.33969,518.30794 L 399.62098,518.30794 C 401.0513,518.27167 402.24206,517.77794 403.19329,516.82674 C 404.14439,515.87561 404.63813,514.68484 404.67449,513.25443 C 404.63813,511.82409 404.14439,510.63332 403.19329,509.68211 C 402.24206,508.73099 401.0513,508.23726 399.62098,508.20091 L 392.30209,508.20091 C 393.48192,502.95504 395.08656,498.11209 397.116,493.67205 C 399.14534,489.23214 402.36187,486.87238 406.7656,486.59277 L 407.98542,486.59277 C 408.98371,486.56744 409.86227,486.66183 410.62108,486.87595 C 411.37977,487.09021 411.77911,487.57668 411.81912,488.33537 C 411.54314,490.77143 410.4395,492.39059 408.50819,493.19284 C 406.57676,493.99522 405.47312,495.57081 405.19727,497.91962 C 405.2553,500.06887 406.01042,501.86955 407.46264,503.32165 C 408.91473,504.77387 410.71541,505.52899 412.86467,505.58702 C 415.91051,505.44186 418.18313,504.03326 419.68256,501.36124 C 421.18184,498.68932 421.9297,495.62527 421.92615,492.16907 C 421.81716,487.78724 420.33596,484.13507 417.48254,481.21252 C 414.62897,478.29013 411.05666,476.77262 406.7656,476.66 C 398.67338,476.96141 391.33272,480.19246 384.7436,486.35317 C 378.15439,492.51403 373.29692,499.7966 370.17118,508.20091 L 360.93544,508.20091 C 359.50505,508.23726 358.31428,508.73099 357.36313,509.68211 C 356.41195,510.63332 355.91822,511.82409 355.88193,513.25443 C 355.91822,514.68484 356.41195,515.87561 357.36313,516.82674 C 358.31428,517.77794 359.50505,518.27167 360.93544,518.30794 L 367.38303,518.30794 L 355.88193,564.1381 C 354.97069,568.06255 353.52579,571.58403 351.54723,574.70256 C 349.56866,577.82105 346.77326,579.46925 343.16101,579.64716 L 342.11545,579.64716 C 341.0336,579.67619 340.10422,579.57453 339.32731,579.34221 C 338.55041,579.10984 338.1438,578.57254 338.10749,577.73031 C 338.38341,575.38143 339.48705,573.80583 341.41842,573.00353 C 343.34979,572.2012 344.45343,570.58204 344.72934,568.14606 C 344.68215,566.00411 343.94881,564.23248 342.52932,562.83115 C 341.10984,561.42981 339.28738,560.70373 337.06194,560.65292 C 334.09228,560.78724 331.84144,562.17405 330.30939,564.81335 C 328.77738,567.45264 328.00774,570.53848 328.00046,574.07087 C 328.10939,578.44548 329.59059,582.06861 332.44407,584.94028 C 335.29757,587.8119 338.86988,589.30036 343.16101,589.40568 C 348.90941,589.17653 354.3351,586.61428 359.4381,581.71891 C 364.54108,576.8235 368.98576,570.96969 372.77215,564.15746 C 376.5585,557.34522 379.35094,550.94927 381.14951,544.96959 L 389.33969,518.30794 z" />
        </g>
      </svg>
      <span class="brandingtext">
        Fiew
      </span>
    </div>
    <div class="midiconf">
      <ul class="midilist">
        <li v-on:click="nextInput">
          <span class="midiname">{{ inputdeviceName }}</span>
          <img class="midiimg" src="./settings_midi.svg">
        </li>
        <li v-on:click="nextOutput">
          <span class="midiname">{{ outputdeviceName }}</span>
          <img class="midiimg" src="./settings_midi.svg">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  methods: {
    nextOutput () {
      this.$store.dispatch('outputdeviceNext')
    },
    nextInput () {
      this.$store.dispatch('inputdeviceNext')
    }
  },
  computed: {
    outputdeviceName () {
      return this.$store.state.outputdeviceName
    },
    inputdeviceName () {
      return this.$store.state.inputdeviceName
    }
  }
}
</script>

<style scoped>
#home {
  margin-top: 2vh;
}
.branding {
  pointer-events: none;
  position: absolute;
  left: 1vw;
  bottom: 3vh;
  width: 20%;
}
.brandingtext {
  position: relative;
  right: 0;
  bottom: 1vh;
  text-align: right;
  font-size: 5vh;
}
.player {
  width: 25%;
  height: 25vh;
}
.midiconf {
  position: absolute;
  right: 3vw;
  bottom: 10vh;
  height: 22vh;
  white-space: nowrap;
}
.midilist {
  text-align: right;
}
.midiimg {
  vertical-align: middle;
  width: 10vh;
  height: 10vh;
}
.midiname {
  font-size: 5vh;
}
ul {
  list-style: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue